/**
 * Dev-only logger — no-op in production.
 */

const isDev = import.meta.env.DEV;

export const logger = {
  error(...args: unknown[]): void {
    if (isDev) console.error(...args);
  },
  warn(...args: unknown[]): void {
    if (isDev) console.warn(...args);
  },
  info(...args: unknown[]): void {
    if (isDev) console.info(...args);
  },
};
